import React from "react";

import { Context } from "../utils";
import { Props } from "./types";

function Flag({ name, retrieveItems, isDisabled = false }: Props) {
  const { registerFlag, removeFlag } = React.useContext(Context);

  React.useEffect(() => {
    !isDisabled && registerFlag({ name, retrieveItems, isDisabled });

    return () => {
      removeFlag(name);
    };
  }, [name, retrieveItems, isDisabled]);

  return (
    <div
      data-infinite-scroll
      data-infinite-scroll-flag-name={name}
      data-infinite-scroll-flag-disabled={isDisabled || undefined}
    />
  );
}

export { Flag };
